import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { useApplicationContext } from '@/app/shared/context/ApplicationContext';
import { useReduxState } from '@/app/shared/context/ReduxStoreContext';
import {
  type GetCianAnalyticsPageViewObjectParams,
  getCianAnalyticsPageViewObject,
} from '@/app/shared/utils/analytics/getCianAnalyticsPageViewObject';

import { type CianAnalyticsPageViewObject } from '@/packages/utils/analytics/CianAnalyticsPageViewObject';

export type UseGetCianAnalyticsPageViewObjectParams = Omit<
  GetCianAnalyticsPageViewObjectParams,
  'applicationContext' | 'reduxState' | 'queryClient'
>;

export function useGetCianAnalyticsPageViewObject(): (
  params?: UseGetCianAnalyticsPageViewObjectParams,
) => CianAnalyticsPageViewObject {
  const queryClient = useQueryClient();
  const reduxState = useReduxState();
  const applicationContext = useApplicationContext();

  return useCallback<(params?: UseGetCianAnalyticsPageViewObjectParams) => CianAnalyticsPageViewObject>(
    (params = {}) => {
      return getCianAnalyticsPageViewObject({
        ...params,
        applicationContext,
        reduxState,
        queryClient,
      });
    },
    [applicationContext, reduxState, queryClient],
  );
}
